import {
  CreatedAt,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort,
  ID,
  IdFilterType,
  UpdatedAt,
  UUID
} from '../../types';

export type FinCategoryID = ID;
export type FinCategoryUUID = UUID;
export type FinCategoryName = string;
export type FinCategoryParentFinCategoryID = FinCategoryID;
export type FinCategoryCreatedAt = CreatedAt;
export type FinCategoryUpdatedAt = UpdatedAt;

export type FetchFinCategoriesCacheKey = FetchItemsCacheKey;

export type FetchFinCategoriesGqlQuery = FetchItemsGqlQuery;

export type FetchFinCategoriesFilters = {
  id?: IdFilterType;
  parentFinCategoryId?: IdFilterType;
};

export type FetchFinCategoriesSort = FetchItemsSort;
export type FetchFinCategoriesPage = FetchItemsPage;
export type FetchFinCategoriesLimit = FetchItemsLimit;

export const enum FetchFinCategoriesSortTypes {
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}
